import { RootState } from "core-integration/src/store";
import { getRules } from "core-integration/src/store/game/reducers";
import { IRules } from "core-integration/src/store/game/types";
import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Box } from "rebass/styled-components";
import ButtonLink from "../ButtonLink";
import Copy from "../Copy";
import { Main, Wrapper } from "../Layout";
import SubHeading from "../SubHeading";
import Title from "../Title";

interface IPropsFromState {
  rules: IRules | null;
}

const Join: React.FC<IPropsFromState> = ({ rules }) => {
  const { t } = useTranslation();
  if (!rules) {
    return null;
  }
  return (
    <Wrapper>
      <Main>
        <Copy>
          <Title>{t("join.title", "Choose a league type to join")}</Title>
          <p>
            {t(
              "join.p1",
              "You can join up to {{ maxPrivateLeagues }} private leagues and {{ maxPublicLeagues }} public leagues.",
              {
                maxPrivateLeagues: rules.league_join_private_max,
                maxPublicLeagues: rules.league_join_public_max,
              },
            )}
          </p>
          <Box mb={4}>
            <SubHeading>
              {t("join.private.title", "Private leagues")}
            </SubHeading>
            <p>
              {t(
                "join.private.p1",
                "Join a private league if somebody has given you a league code to enter.",
              )}
            </p>

            <ButtonLink to="private" variant="primary">
              {t("join.private.button", "Join private league")}
            </ButtonLink>
          </Box>
          <SubHeading>{t("join.public.title", "Public leagues")}</SubHeading>
          <p>
            {t(
              "join.public.p1",
              "Join a public league to play against a small, randomly selected group of other game players.",
            )}
          </p>
          <ButtonLink to="public" variant="primary">
            {t("join.public.button", "Join public league")}
          </ButtonLink>
        </Copy>
      </Main>
    </Wrapper>
  );
};

const mapStateToProps = (state: RootState): IPropsFromState => ({
  rules: getRules(state),
});

export default connect(mapStateToProps)(Join);
